<template>
    <button ref="buttonRef" class="large-button" :class="[styleVariant, { loading: loading }]" v-bind="$attrs" type="button" @click="removeFocus()">
        <div v-if="loading">
            <loading />
        </div>
        <div v-else class="button-content">
            <div class="icon">
                <slot name="icon" />
            </div>
            <div class="label">
                <slot />
            </div>
            <div v-if="plusIcon" class="plus">
                <glyph-icon :type="GlyphType.Plus" />
            </div>
        </div>
    </button>
</template>

<script setup>
import { ref, computed } from 'vue';
import { GlyphIcon, GlyphType, Loading } from 'ihunter-pathfinder-components';

const props = defineProps({
    plusIcon: {
        // Should this be the same as Drone Button for more Glyphs?
        type: Boolean,
        default: false,
    },
    variant: {
        type: String,
        default: 'primary',
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const styleVariant = computed(() => {
    return props.variant;
});

const buttonRef = ref(null);

function removeFocus() {
    requestAnimationFrame(() => {
        buttonRef.value?.blur();
    });
}
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use 'ihunter-pathfinder/styles/buttons' as PathfinderButton;

.large-button {
    @include PathfinderButton.Button;

    height: Pathfinder.$button-height-large;
    width: 100%;
    max-width: Pathfinder.$max-form-width;
}

.plus {
    margin-left: -(Pathfinder.$space-50);

    ::v-deep(svg) {
        height: Pathfinder.$icon-micro;
        width: Pathfinder.$icon-micro;
    }
}
</style>
